/**
 * Display overrides for source slugs whose default title-cased form
 * isn't how the person is commonly known. Extend this map as needed.
 *
 * ``karunanidhi``: M. Karunanidhi is universally referred to by his
 * honorific ``Kalaignar`` (Tamil: கலைஞர்), so we surface that name
 * rather than the surname-based slug used in the OKF source bundle.
 */
const DISPLAY_OVERRIDES: Record<string, string> = {
    karunanidhi: 'Kalaignar',
    // Classical commentators — the default title-case would already
    // produce ``Manakkudavar`` / ``Parimelazhagar`` correctly, but we
    // list them here so the canonical spellings live in one place.
    manakkudavar: 'Manakkudavar',
    parimelazhagar: 'Parimelazhagar',
    varadharasanar: 'Varadharasanar',
};

/**
 * Convert a source slug (e.g. ``drew-lazarus`` or ``solomon-pappaiah``)
 * to a display label (``Drew Lazarus``, ``Solomon Pappaiah``). Slugs
 * that have a curated display name in ``DISPLAY_OVERRIDES`` use that
 * instead of the default title-case.
 */
export function formatSource(slug: string): string {
    const override = DISPLAY_OVERRIDES[slug];
    if (override) return override;
    return slug
        .split('-')
        .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : word))
        .join(' ');
}
